module.exports = __webpack_public_path__ + "img/price-settings-mobile-ru.cce459b7.jpg";